import { render, staticRenderFns } from "./BookmarkCardList.vue?vue&type=template&id=1a12d691&scoped=true"
import script from "./BookmarkCardList.vue?vue&type=script&lang=js"
export * from "./BookmarkCardList.vue?vue&type=script&lang=js"
import style0 from "./BookmarkCardList.vue?vue&type=style&index=0&id=1a12d691&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a12d691",
  null
  
)

export default component.exports